import { objectMergeBool } from "~/common/helpers/object-merge-bool";
import type { GetAllItemPrototypesDto } from "~/common/interfaces/dto/item-prototypes/get-all-item-prototypes.dto";
import type { Filter } from "~/common/interfaces/filter.interface";

export const serializeItemPrototypeFilters = (updatedFilters: Filter[]) => {
	const serializedFilters: GetAllItemPrototypesDto = {};
	updatedFilters.forEach((filter) => {
		const value = filter.value as Record<string, boolean>;

		if (filter.name === "Status") {
			const mergedBool = objectMergeBool(value);
			if (mergedBool !== null) {
				serializedFilters.isActive = mergedBool;
			}
		}
	});

	return serializedFilters;
};
